import { render, staticRenderFns } from "./channel-summary.vue?vue&type=template&id=e1c2ee62&scoped=true"
import script from "./channel-summary.vue?vue&type=script&lang=ts"
export * from "./channel-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c2ee62",
  null
  
)

export default component.exports